import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.logistics-vehicle')
  .factory('LogisticsVehicleLocationAPI', LogisticsVehicleLocationAPI);

function LogisticsVehicleLocationAPI(): BringozApi {
  return {
    base: `/location/LogisticsVehicle`,
    infiniteScroll: {
      address: `/location/LogisticsVehicle`,
      cmd: 'GET'
    }
  }
}
